module.exports = __webpack_public_path__ + "static/media/apartment-large.ee737d20.webp";